export default {
  YourUsername: '您的用户名',
  YourPassword: '您的密码',
  Login: '登录',
  LoginGitHub: '使用GitHub登录',
};
